import { Avatar } from "@mui/material";
import ModalBox from "components/modal/ModalBox";
import NotFound from "components/not-found/NotFound";
import useDebounce from "hooks/useDebounce";
import useFullPageLoader from "hooks/useFullPageLoader";
import React, { useEffect, useState, useLayoutEffect } from "react";
import { toast } from "react-hot-toast";
import Pagination from "react-js-pagination";
import { useSearchParams } from "react-router-dom";
import { dateFormat } from "utils";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Button } from "components/Button/Button";
import Switch from "components/Switch/Switch";
import {
  deleteCityTestimonial,
  getStateTestimonials,
  updateCityTestimonialStatus,
  getCityDropdown,
} from "services/citypages/citytestimonials";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import FancyVideo from "react-videojs-fancybox";
import { Table } from "react-bootstrap";
import Link from "components/Button/Link";
import IconButton from "components/Button/IconButton";

const ViewCityTestiMonials = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  let blockStatus = searchParam.get("type") || "";
  const [record, setRecord] = useState([]);
  const [total, setTotal] = useState(0);
  const [blockModal, setBlockModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

  const [search, setSearch] = useState(searchParam.get("query") || "");
  const debounceValue = useDebounce(search || "", 300);
  const [allCity, setAllCity] = useState([]);
  //**********testimonials Listing**********/
  const testimonialList = async (page = activePage, search = debounceValue, cityId =blockStatus) => {
    try {
      showLoader();
      const res = await getStateTestimonials({
        page,
        search,
        stateid: cityId,
      });
      hideLoader();
      if (res.code === 200) {
        const { rows, count } = res.data.Statewisetestimonials;
        setRecord(rows || []);
        setTotal(count || 0);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };
  // --------------- city dropdown ----------------//
    React.useLayoutEffect(() => {
    const getCityDropdownData = async () => {
      try {
        const res = await getCityDropdown();
        if (res.code === 200) {
          setAllCity(res.data.statewisecenters || []);
        } else {
          toast.error(res.message);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
      }
    };
    
    getCityDropdownData();
  }, []);


  const userTypeSelection = (event) => {
    searchParam.set("page", 1);
    searchParam.set("type", event);
    setSearchParam(searchParam);
  };
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };

  //********Reset Filter****** */
  const restFilter = () => {
    setSearch("");
    searchParam.delete("type");
    setSearchParam(searchParam);
  };

  // update status function
  const updateTestimonialStatusHandler = async () => {
    if (selectedId) {
      try {
        setSubmitLoading(true);
        const res = await updateCityTestimonialStatus({
          id: selectedId,
        });
        if (res.code === 200) {
          testimonialList();
          toast.success(res.message);
          setBlockModal(false);
          setSubmitLoading(false);
        } else {
          toast.error(res.message);
          setSubmitLoading(false);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
        setSubmitLoading(false);
      }
    }
  };

  // delete testimonial function
  const deleteTestimonialHandler = async () => {
    if (selectedId) {
      try {
        setSubmitLoading(true);
        const res = await deleteCityTestimonial({
          id: selectedId,
        });
        if (res.code === 200) {
          testimonialList();
          toast.success(res.message);
          setDeleteModal(false);
          setSubmitLoading(false);
        } else {
          toast.error(res.message);
          setSubmitLoading(false);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
        setSubmitLoading(false);
      }
    }
  };

  useEffect(() => {
    if (debounceValue) {
      searchParam.set("query", debounceValue);
    } else {
      searchParam.delete("query");
    }
    if (activePage === 1) {
      searchParam.delete("page");
    }
    if (!blockStatus) {
      searchParam.delete("type");
    }
    setSearchParam(searchParam);
    testimonialList(activePage, debounceValue, blockStatus);
  }, [searchParam, debounceValue, blockStatus]);

  useEffect(() => {
    if (search) {
      searchParam.set("page", "");
    }
  }, [search]);

  return (
    <React.Fragment>
      <title>Shubhra Viraj | State Testimonial</title>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="SearchBox">
                <div className="div_wrap">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control"
                    name="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                <div className="div_no_wrap mx-3"></div>
                <div className="div_wrap">
                  <select
                    className="form-control"
                    onChange={({ target }) => userTypeSelection(target.value)}
                    value={blockStatus}
                    name={blockStatus}
                  >
                    <option id="blockStatus" value="">
                      Select State
                    </option>
                    {allCity &&
                      allCity.map(({ id, statename }) => {
                        return (
                          <option value={id} key={id}>
                            {statename}
                          </option>
                        );
                      })}
                  </select>
                </div>
                <Button className="refresh_btnn mx-2" onClick={restFilter}>
                  <i className="fa fa-refresh"></i>
                </Button>
                <div>
                  <Button to="list" type="acl" role={850009}>
                    Map City Testimonials
                  </Button>
                </div>&nbsp;&nbsp;
                <div>
                  <Button to="add" type="acl" role={850009}>
                    Add State Testimonial
                  </Button>
                </div>
              </div>
              <h4 className="Title">State Testimonials</h4>
            </div>
            <div className="TableList overflow-auto table-responsive">
              {loader}
              <Table bordered className="table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Student Image</th>
                    <th>Student Name</th>
                    <th>Rank</th>
                    <th className="text-center">Video</th>
                    <th className="text-center">State</th>
                    <th className="text-center">Year</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map(
                      (
                        {
                          studentName,
                          status,
                          id,
                          state,
                          rank,
                          yearOfStudy,
                          media,
                          studentImage,
                        },
                        i
                      ) => (
                        <tr key={i}>
                          <td>{++i + (activePage - 1) * 10}</td>
                          <td>
                            <div className="text-center">
                              <Avatar
                                src={studentImage}
                                sx={{ width: 36, height: 36 }}
                                alt={studentName}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="">{studentName}</div>
                          </td>
                          <td>
                            <div className="">{rank}</div>
                          </td>

                          <td>
                            <div className="fancy-video">
                              <FancyVideo
                                source={media}
                                poster={studentImage}
                                id={`sintel${i}`}
                              />
                            </div>
                          </td>
                          <td className="text-center">{state}</td>
                          <td className="text-center">{yearOfStudy}</td>
                          
                          <td>
                            <Switch
                              checked={status}
                              onChange={() => {
                                setSelectedId(id);
                                setBlockModal(true);
                              }}
                              type="acl"
                              role={850012}
                            />
                          </td>

                          <td>
                            <div className="d-flex justify-content-center">
                              <Link
                                to={`update/${id}`}
                                className="m-0"
                                type="acl"
                                role={850010}
                              >
                                <IconButton
                                  aria-label="view"
                                  className="px-1 py-0"
                                >
                                  <EditIcon sx={{ color: "#4971B2" }} />
                                </IconButton>
                              </Link>

                              <IconButton
                                aria-label="view"
                                className="px-1 py-0"
                                onClick={() => {
                                  setSelectedId(id);
                                  setDeleteModal(true);
                                }}
                                type="acl"
                                role={850011}
                              >
                                <DeleteIcon sx={{ color: "#ff0000" }} />
                              </IconButton>
                            </div>
                          </td>
                        </tr>
                      )
                    )
                  ) : (
                    <NotFound cols={12} />
                  )}
                </tbody>
              </Table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {/* block or unblock model */}
      <ModalBox
        status={blockModal}
        onClose={() => setBlockModal(false)}
        title={"Change Status"}
        description={"You want to change status of this testimonial ?"}
        customizedFooter={
          <Button
            onClick={updateTestimonialStatusHandler}
            {...submitButtonElement}
          >
            Yes
          </Button>
        }
      />

      {/*delete model */}
      <ModalBox
        status={deleteModal}
        onClose={() => setDeleteModal(false)}
        title={"Delete Testimonial"}
        description={"Are you sure want to delete this testimonial ?"}
        customizedFooter={
          <Button onClick={deleteTestimonialHandler} {...submitButtonElement}>
            Yes
          </Button>
        }
      />
    </React.Fragment>
  );
};

export default ViewCityTestiMonials;
